module.exports = __webpack_public_path__ + "img/P9220234.1e4b4af7.jpg";